import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';

import { Observable } from 'rxjs';
import { AppQlikResponseDTO } from '../../models/entities/app-qlik-response-dto';
import { restServices } from 'src/app/rest.service';
import { environment } from 'src/environments/environment';
import { get } from 'scriptjs';

declare var $: any;

export type EntityResponseType = HttpResponse<any>;
type EntityArrayResponseTypeAppsQlik = HttpResponse<AppQlikResponseDTO[]>;

@Injectable()
export class QlikService {

    public resourceQlikApps = environment.api_url + restServices.qlikApps;

    constructor(private http: HttpClient) { }

    public getQlikTicket(userId: string) {
        return this.http.post((environment.api_url + 'qlik-ticket'), userId, { responseType: 'text' });
    }

    public getMashupEngine(): any {
        return new Promise((resolve, reject) => {
            // Script già caricato
            if (window['OmnitoolMashupEngine']) {
                if (window['OmnitoolMashupEngine'].initialized) {
                    // script già inizializzato, risolvo direttamente l'engine
                    resolve(window['OmnitoolMashupEngine']);
                } else {
                    // Script non inizializzato, inizializzo e risolvo l'engine
                    window['OmnitoolMashupEngine'].Initialize().then(
                        () => resolve(window['OmnitoolMashupEngine']),
                        () => reject('failed to initialize script')
                    );
                }
            } else {
                // Script non caricato, carico inizializzo e risolvo
                // Ottengo l'authorization token dal server
                this.http.get(environment.api_url + 'mashup-engine').toPromise().then(
                    (response: any) => {
                        // console.log('token', response.Token);
                        // Carico lo script del mashup engine e lo inizializzo
                        get('https://' + environment.qlik_host + '.net:8092/MashupEngine/Script?authorizationToken=' + response.Token,
                            () => {
                                window['OmnitoolMashupEngine'].Initialize().then(
                                    () => resolve(window['OmnitoolMashupEngine']),
                                    (reason) => {
                                        console.log(reason);
                                        reject('failed to initialize script');
                                    }
                                );
                            }
                        );
                    },
                    () => reject('failed to obtain authorization token')
                );
            }
        });
    }

    getAllApps(): Observable<EntityArrayResponseTypeAppsQlik> {
        return this.http.get<AppQlikResponseDTO[]>(this.resourceQlikApps, {observe: 'response'});
    }

}
